module.exports = __webpack_public_path__ + "static/media/Live3.904354b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/liveroadcast/Live3.mp4
// module id = FewT
// module chunks = 1